import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { Col, UncontrolledTooltip } from 'reactstrap';

const Column = (props) => {
  const {
    content, contentSize, opportunityId, isGridView,
  } = props;

  const contentTrimmed = content.replace(/[^a-zA-Z ]/g, '').split(' ').join('-');
  // added "a" char to the start of the string because number in the start of the string causes the UI to break.
  const tooltipId = `a${contentTrimmed}-tooltip${opportunityId}`.toLowerCase();

  return (
    <Col className={classnames('opportunity-card__table__col mt-4', {
      'opportunity-card__table__col__grid': isGridView,
    })}
    >
      <div className="opportunity-card__table__col__wrapper">
        <div
          id={tooltipId}
          className={classnames('opportunity-card__table__col__content', {
            'font-32': contentSize === 'lg',
            'font-20': contentSize !== 'lg',
          })}
        >
          {content}
        </div>

        <UncontrolledTooltip placement="bottom-start" target={tooltipId}>
          {content}
        </UncontrolledTooltip>
      </div>
    </Col>
  );
};

Column.defaultProps = {
  content: '',
  contentSize: '',
  isGridView: false,
};

Column.propTypes = {
  opportunityId: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
  ]).isRequired,
  content: PropTypes.string,
  contentSize: PropTypes.string,
  isGridView: PropTypes.bool,
};

export default Column;
